import { connect } from 'react-redux';
import isEmpty from 'lodash.isempty';
import { selectors } from '../../../root/reading/root';
import AmpNavWrapper from '../../../features/ampNavWrapper/AmpNavWrapper';
import { fetchAmpNavData } from '../../../api/enrollment/shared/enrollmentActions';
import {
    exitDemoMode as exitDemoModeHandler,
    launchDemoMode,
} from '../../../api/demoMode/reading/demoModeActions';
import { LICENSE } from '../../../constants/shared/CommonConstants';

const mapStateToProps = state => {
    const isStaffConfigFetched = selectors.isStaffConfigFetched(state);
    const staffConfig = selectors.getAmpNavConfig(state);
    const isDemoModeOn = selectors.getIsDemoModeOn(state);
    const licensingInfo = selectors.getLicensingInfo(state);

    const isDataReady = isEmpty(selectors.getStudentIds(state))
        ? selectors.isDataFetched(state)
        : selectors.isResultDataFetched(state);

    return {
        isStaffConfigFetched,
        staffConfig,
        isDemoModeOn,
        isDataReady,
        licensingInfo,
    };
};

const mapDispatchToProps = dispatch => ({
    fetchStaffConfig: () => dispatch(fetchAmpNavData()),
    handleToggleDemo: () => {
        localStorage.setItem('inDemo', true);
        dispatch(launchDemoMode());
    },
    exitDemoMode: () => {
        dispatch(exitDemoModeHandler(true, false));
    },
});
const mergeProps = (stateProps, dispatchProps, ownProps) => {
    const { staffConfig, isDataReady, isDemoModeOn, licensingInfo } = stateProps;
    const { handleToggleDemo, exitDemoMode } = dispatchProps;
    const isDemoModeAvailable = licensingInfo.includes(LICENSE.D8);
    const demoLink = {
        text: 'Demo',
        reload: false,
        displayed: isDataReady,
        isActive: isDemoModeOn,
        onTabClick: handleToggleDemo,
    };
    const config = {
        ...staffConfig,
        mainNavTabs: isDemoModeAvailable
            ? [...staffConfig.mainNavTabs, demoLink]
            : staffConfig.mainNavTabs,
        ...(isDemoModeOn ? { logoutHandler: () => exitDemoMode() } : {}),
    };
    return {
        ...stateProps,
        ...dispatchProps,
        ...ownProps,
        staffConfig: config,
    };
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(AmpNavWrapper);
